import { ActionMenu } from 'components/ActionStyles/ActionStyles'
import RightArrow from 'components/icons/RightArrow'
import {
  CandCount,
  CardSectionFlex,
  CardText,
  CardsDiv,
  CardsFlex,
  CardsRowFlex,
  CardsValue,
  RoleFlex,
  RoleNumber,
  RoleTitle,
} from 'modules/Drives/ViewDriveRole/Style/style'
import React from 'react'
import { COLORS } from 'theme'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'

export const roleMenu = (onRoleChange, roleMenu = []) => (
  <ActionMenu
    width="335px"
    items={
      Array.isArray(roleMenu)
        ? roleMenu?.map((role, index) => {
            return {
              key: index,
              label: (
                <RoleFlex
                  row
                  spaceBetween
                  centerVertically
                  onClick={() => onRoleChange(role?.roleId)}
                >
                  <RoleFlex column>
                    <RoleNumber>Role {getZeroBeforeInt(index + 1)}</RoleNumber>
                    <RoleTitle>{role?.roleName}</RoleTitle>
                  </RoleFlex>
                  <CandCount>
                    {getZeroBeforeInt(role?.candidateCount)}
                  </CandCount>{' '}
                </RoleFlex>
              ),
            }
          })
        : Object.keys(roleMenu)
    }
  />
)

function isObject(value) {
  return typeof value === 'object' && value !== null
}

const DriveRoleMetrics = ({
  rolesMetrics,
  selectedRound,
  setSelectedRound,
  setSearchParams,
  setCurrentPage,
  setSelectedCandidateId,
  setSelectedCandidate,
  setCurrentTab,
  setStatus,
  setFilterStatus,
  setScoreStatus,
  setCurrentScoreTab,
  setType,
  setSearchValue,
  setCurrentScorePage,
  setSearchScoreValue,
  setPanelData,
  setPanelValue,
  setLastPanelId,
  setScorePayload,
  setIsAllSelected,
  isDisabled,
  setTabValue,
  getConflictCandidates,
  setConflictData,
roleId
}) => {
  const onClickRound = (
    round,
    type,
    assessment,
    extAssmnts,
    panelId = 0,
    roundId = null
  ) => {
    setCurrentPage(0)
    setSearchValue('')
    setCurrentScorePage(0)
    setSearchScoreValue('')
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setIsAllSelected(false)
    if (round === 'all_candidates') {
      setCurrentTab('APPLIED_TAB')
      setStatus('APPLIED_TAB')
      setFilterStatus('APPLIED_TAB')
    } else {
      setCurrentTab('ACTIVE')
      setStatus('ACTIVE')
      setFilterStatus('ACTIVE')
    }
    setSelectedRound(round)
    setSearchParams({
      stage: round,
      roundId: roundId,
      type: type || 'all',
      assessment: assessment || 'Test Gorilla',
      isUpload: isObject(extAssmnts),
      assessmentId: extAssmnts?.id,
      isBack: false,
    })
    setType({ type: type, assessmentType: assessment, round: round })
    setCurrentScoreTab('INVITED,STARTED,COMPLETED,ABSENT')
    setScoreStatus('INVITED,STARTED,COMPLETED,ABSENT')
    setPanelData('')
    setPanelValue('all')
    setLastPanelId(panelId)
    setScorePayload({})
    setTabValue('ACTIVE')
    resolveConflictRefresh(round, roundId)
  }
  const resolveConflictRefresh = async (stage,roundId) => {
    const getConflictData = await getConflictCandidates(roleId, {
      pageNo: 0,
      pageLimit: 10,
      roundId: roundId,
      stage: stage,
    })

    setConflictData(getConflictData)
  }
  return (
    <div>
      <CardsRowFlex row wrap>
        <CardsDiv disabled={isDisabled}>
          <CardsFlex
            column
            onClick={() => onClickRound('all_candidates')}
            isSelected={selectedRound === 'all_candidates'}
            disabled={isDisabled}
          >
            <CardText>All Candidates</CardText>
            <CardsValue>
              {getZeroBeforeInt(rolesMetrics[0]?.candidateCount)}
            </CardsValue>
          </CardsFlex>
        </CardsDiv>
        {rolesMetrics[0]?.rounds?.map((round, index) => (
          <CardSectionFlex
          key={index + round?.roundName}
          centerVertically
          disabled={isDisabled}
          >
            <CardsFlex
              column
              onClick={() =>
                onClickRound(
                  round?.roundName,
                  round?.type,
                  round?.assesmentType,
                  round?.extAssmnts,
                  round?.lastPanelId,
                  round?.roundId
                )
              }
              isSelected={selectedRound === round?.roundName}
              disabled={isDisabled}
            >
              <CardText>
                {round?.roundName == 'offer'
                  ? 'Intent to Offer'
                  : round?.roundName}
              </CardText>
              <CardsValue>{getZeroBeforeInt(round?.count)}</CardsValue>
            </CardsFlex>

            {rolesMetrics[0]?.rounds?.length - 1 !== index && (
              <RightArrow color={COLORS.GREY_T_80} />
            )}
          </CardSectionFlex>
        ))}
      </CardsRowFlex>
    </div>
  )
}

export default DriveRoleMetrics
